import { useParams } from 'react-router-dom';

import Graphics from 'src/components/Graphics';
import Playlists from 'src/components/Playlists';
import { Panel, PanelGroup } from 'src/components/ResizeablePanel';

function LayoutPlaylist() {
  const { rundownId } = useParams<{ rundownId: string }>();

  if (!rundownId) return null;

  return (
    <div className="max-w-2xl w-full h-full mx-auto [&>div]:bg-elevated-1">
      <PanelGroup direction="vertical">
        <Playlists rundownId={rundownId} view="select" />
        <Panel defaultSize={42}>
          <Graphics />
        </Panel>
      </PanelGroup>
    </div>
  );
}

export default LayoutPlaylist;
